import http from '@/biz/http.mjs'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../../MenuButton.jsx'

export default function MenuButtonSetParentRelation(props) {
    const map = useMapContext()
    const {mapTypeCode} = map.useMetaData()
    const selectedNodes = map.useSelectedNodes()

    if ('_UI_MAP' !== mapTypeCode) {
        return null
    }

    const nodes = [...selectedNodes].filter(n => (
        'UI' === n.data.bizNodeType &&
        'UI' === n.parent?.data.arTypeCode &&
        'AR' === n.parent?.data.bizNodeType
    ))

    if (0 === nodes.length) {
        return null
    }

    const onClick = async () => {
        const uiIds = nodes.map(n => n.data.pkid)
        const {uiCode, pkid} = map.root.data

        await runAsync(
            () => http.post(
                '/umuis/setParentCodeForUis',
                {pkid, pUiCode: uiCode, uiIds}
            ),

            {action: '设置父子关系'}
        )
    }

    return (
        <MenuButton
            onClick={onClick}
            {...props}
        >
            设置父子关系
        </MenuButton>
    )
}
